/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - ページが見つかりません",
  "ComingSoon": "近日公開",
  "YesanPersonalFinance": "Yesan, ファイナンス",
  "Yesan": "Yesan",
  "PersonalFinance": "個人ファイナンス",
  "YesanDownload": "ダウンロード",
  "ThisWebsiteUsesCookies": "当社は、サイトのパフォーマンスと利用状況に関する情報を収集・分析し、ソーシャルメディア機能を提供するためにクッキーを使用しています。続行することにより、あなたは私たちの",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "経済的に自由になる",
  "inStepsAndActions": "8つのステップと3つのアクションで",
  "TrackPlanAnalyze": "追跡する。計画を立てる。分析する。",
  "FTrack": "1.追跡",
  "FPlan": "2.計画",
  "FAnalyze": "3.分析",
  "Features": "特徴",
  "FeaturesSubHeading": "純粋な初心者の方、すでに金融リテラシーをお持ちの方、このアプリは経済的に自由になるために必要なアプリです。",
  "ManageAccounts": "口座管理",
  "CashLiquidFixedAssetsLiabilities": "現金、流動資産、固定資産、負債。",
  "TrackTransactions": "取引の追跡",
  "IncomesExpensesTransferInvestments": "収入、支出、移動、投資。",
  "ImportExport": "インポート/エクスポート",
  "YourDataAlwaysAccessible": "あなたのデータにいつでもアクセス。",
  "PlanYourFreedom": "自由を計画する",
  "StepsAwayFromFI": "経済的自立への8つのステップ。",
  "BudgetsAndGoals": "予算と目標",
  "CheckYourProgressAndAchieve": "進捗状況を確認し、経済的目標を達成しましょう。",
  "DashboardAndAnalytics": "ダッシュボードと分析",
  "ReviewLearnOptimizeWith": "チャート、インサイト、ツールで確認、学習、最適化。",
  "Security": "セキュリティ",
  "MilitaryGradeEncryption": "ミリタリーグレードの暗号化、バイオメトリサポート、データはデバイスに保存されます。",
  "OfflineMode": "オフラインモード",
  "YourDataAlwaysAccessibleAndModif": "データはいつでもアクセス、変更可能。",
  "Track": "追跡",
  "Income": "収入",
  "Expense": "経費",
  "Transfer": "送金",
  "transactionsAndManageAccounts": "様々な口座の管理",
  "checkings": "当座預金",
  "savings": "普通預金",
  "realEstate": "不動産",
  "stocks": "株式市場",
  "bonds": "債券",
  "crypto": "暗号通貨",
  "notes": "紙幣、キャッシュウォレット",
  "envelopes": "封筒",
  "privateEquity": "プライベート・エクイティ",
  "metal": "メタル",
  "retirement": "退職金",
  "lifeInsurance": "生命保険",
  "intellectualProperty": "知的財産",
  "otherLiquidAsset": "その他流動資産",
  "otherFixedAsset": "その他固定資産",
  "mortgage": "住宅ローン",
  "loan": "消費者ローン",
  "creditCard": "クレジットカード",
  "otherLiability": "その他の負債",
  "AccountsManagement": "口座管理",
  "MultipleAccountsTypesAndGrouping": "複数の口座タイプとグループ化",
  "LinkAccounts": "金融機関口座とのリンク（一部の国でのみ利用可能）",
  "SmartAccounts": "スマート口座",
  "AddEditDeleteTransactions": "取引の追加・編集・削除",
  "TickVerifiedTransactions": "確認済みの取引にチェックを入れる",
  "CategorizeTransactions": "取引の分類",
  "TagTransactions": "取引のタグ付け",
  "TrackKakeiboType": "カケイボタイプの追跡",
  "TrackInvestments": "投資の追跡（一部の国でのみ利用可能）",
  "ImportFromCSVFile": "CSVファイルから取引の全件または差分をインポート",
  "ExportToCSVFile": "CSVファイルへのエクスポート",
  "stepsTowardsFIPlanBudgetingReachGoals": "経済的自立に向けた8つのステップ、詳細な予算管理、経済的目標への迅速な到達。",
  "levelsTowardsFI": "経済的自立に向けた8つのレベル",
  "EstablishBudgetsPer": "口座ごとの予算設定",
  "account": "口座",
  "accountType": "口座タイプ",
  "KakeiboType": "かけいぼタイプ",
  "category": "カテゴリー",
  "tag": "タグ",
  "label": "ラベル",
  "TrackBudgetsPerFrequency": "頻度ごとの予算を追跡",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "支出、残高、キャッシュフロー、行動に関する目標の作成",
  "TrackGoalsProgress": "目標の進捗を追跡",
  "ReviewLearnOptimizeWithReportsCharts": "レポート、チャート、トレンド、インサイト、ツールでレビュー、学習、最適化。",
  "Dashboard": "ダッシュボード",
  "FSNetWorth": "財務諸表：純資産",
  "FSPnL": "財務諸表損益計算書",
  "FSBalanceSheetAssetsLiabilities": "財務諸表貸借対照表、資産、負債",
  "FSCashFlow": "財務諸表キャッシュフロー計算書、借方貸方、フロー",
  "FSFlows": "財務諸表フロー",
  "FSRatios": "財務諸表比率",
  "TrendsMonthEnd": "月末の傾向収入と支出、キャッシュフロー",
  "TrendsPerformance": "業績推移：前年同期比、前月比、WoW",
  "IncomeTrendsPer": "収入トレンド",
  "SpendingTrendsPer": "支出動向",
  "RecurringItemsIE": "経常項目収入と支出",
  "DebtProgressTrends": "負債進捗推移",
  "KakeiboMTDReviewTrends": "カケイボMTDレビュー、先月の動向",
  "FIWCLE": "経済的自立ウォールチャート、ライフエナジー別支出",
  "DebtPaydownSnowballAvalanche": "借金返済雪だるま式、雪崩式",
  "FullyCustomizableAnalyticsRange": "完全にカスタマイズ可能な分析時間範囲",
  "ContactUs": "お問い合わせ",
  "Privacy": "プライバシー",
  "Terms": "利用規約",
  "About": "について",
  "IAgreeToThe": "私は",
  "AndThe": "および",
  "PrivacyPolicy": "プライバシーポリシー",
  "TermsOfUse": "利用規約",
  "DigitalSoftwareExperienceTagline": "デジタル・ソフトウェア体験",
  "DigitalExperience": "デジタル体験",
  "SoftwareForTheModernWorld": "現代社会のためのソフトウェア",
  "MobileApplications": "モバイル・アプリケーション",
  "forConnectedAndOfflineHumans": "コネクテッド・ヒューマンとオフライン・ヒューマンのための",
  "CloudSaaS": "クラウドSaaS",
  "ResponsiveAndWebServices": "レスポンシブ・Webサービス",
  "PersonalFinanceServices": "パーソナル・ファイナンス・サービス",
  "YS_p1": "Yesanは、消費者向けの最先端モバイルアプリケーション開発を専門とするダイナミックなソフトウェア企業です。今日のテクノロジーに精通したユーザーの進化するニーズと嗜好を深く理解し、ユーザーの生活を豊かにする直感的で魅力的、かつ機能豊富なモバイル体験を創造することに専心しています。",
  "YS_p2": "Yesanの使命の中核は、革新性と創造性への絶え間ないコミットメントであり、各製品はシームレスな機能と卓越したユーザーエクスペリエンスを提供するために細心の注意を払って作られています。",
  "PersonalFinanceApplication": "パーソナルファイナンスアプリケーション",
  "YPF_p1": "Yesanのパーソナルファイナンスアプリケーションは、包括的な財務管理ツールに指先ひとつでアクセスできるように設計された、最先端のパーソナルファイナンスモバイルアプリケーションです。洗練された直感的なインターフェースにより、あらゆるレベルの金融リテラシーのユーザーに対応し、総合的な財務管理アプローチを提供します。",
  "YPF_p2": "主な機能には、予算追跡、支出分類、リアルタイムの取引監視などがあり、ユーザーは自分の支出習慣を簡単に把握することができます。また、このアプリはカスタマイズ可能な予算管理オプションを提供しており、ユーザーは経済的な目標を設定し、長期的な進捗状況を追跡することができます。",
  "YPF_p3": "さらに、Yesan, Personal Financeはセキュリティに重点を置いており、最先端の暗号化プロトコルを採用することで、ユーザーの重要な財務情報を保護しています。銀行レベルのセキュリティ対策が施されているため、ユーザーはプライバシーを損なうことなく、安心して口座の紐付けや取引の同期を行うことができます。",
  "YPF_p4": "Yesan, Personal Financeは、基本的な予算管理にとどまらず、財務上の意思決定を最適化するための洞察に満ちた分析とパーソナライズされた推奨を提供します。このアプリは、潜在的な貯蓄機会の特定、投資ポートフォリオの監視、または債務返済戦略の管理など、ユーザーの財務目標の達成を支援するためにカスタマイズされた洞察を提供します。",
  "Discover": "発見",
  "Firstname": "名",
  "Lastname": "姓",
  "Company":"会社概要",
  "Subject": "件名",
  "Email": "Eメール",
  "Message": "メッセージ",
  "ThankYouForContactingUs": "ご連絡ありがとうございます。",
  "ValidFirstnameRequired": "有効な姓が必要です。",
  "ValidLastnameRequired": "有効な姓が必要です。",
  "ValidEmailAddressRequired": "有効なメールアドレスを入力してください。",
  "ValidSubjectRequired": "有効な件名を選択してください。",
  "ValidMessageRequired": "有効なメッセージを入力してください。",
  "UnableToSendTheFormPleaseRetryLater": "送信できません。後で再試行してください。",
  "Information": "インフォメーション",
  "Sales":"売上高",
  "Support": "サポート",
  "Press": "プレス",
  "Partnership": "パートナーシップ",
  "Other": "その他",
  "Blog": "ブログ",

  "Accept":"受け入れる",
  "Decline":"減少",

  "WorklogCalendar":"Jira 用ワークログカレンダー",

  "DirectlyAccessibleInProjectApps":"プロジェクトアプリから直接アクセス",
  "VisualizeWhereYouSpentYourTime":"どこに時間を費やしたかを可視化",
  "AllYourWorklogsInACalendar":"すべてのワークログをカレンダーに表示",
  "MonthSummary":"月のサマリー",
  "CheckIfYouForgotToLogTime":"時間の記録忘れをチェック",
  "DirectlyAccessTheIssuesAndUpdateTime":"課題に直接アクセスして時間を更新",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"ワークログアイテムをクリックすると、課題に直接アクセスし、記録した時間を編集できます。",
  "AlsoAvailableInDarkMode":"ダークモードでも利用可能",
  "DirectlyLogWorkOnTheCalendarVisually":"視覚的にカレンダーに直接仕事を記録",
  "ClickOnTheCalendarToCreateNewWorklog":"カレンダーをクリックし、新しいワークログを作成",

  "AppsForAtlassian":"アトラシアン向けアプリ",
  "YCL_p1":"月、週、作業週、日ビューですべてのワークログをカレンダー上に可視化します。",
  "YCL_p2":"カレンダーから直接、タイムスロットを選択して作業を記録します。",
  "YCL_p3":"タイムシートの時間を記録し忘れていないか確認できます。",
  "YCL_p4":"あなたの言語で利用可能： 英語（英国）、英語（米国）、中国語（簡体字）、中国語（繁体字）、チェコ語、デンマーク語、オランダ語、エストニア語、フィンランド語、フランス語、ドイツ語、ハンガリー語、アイスランド語、イタリア語、日本語、韓国語、ノルウェー語、ポーランド語、ポルトガル語（ブラジル）、ポルトガル語（ポルトガル）、ロシア語、スペイン語、スウェーデン語、トルコ語。",

  "Kakeibo":"カケイボ",
  "Genea":"Genea",
  "FinancialPortfolio":"Jira用財務ポートフォリオ",
  "BringRealFinancialPortfolio":"Jiraに本格的な財務ポートフォリオ管理機能をもたらします。予算、設備投資（CapEx）／運営費（OpEx）、プロジェクトコストを一元管理できます。",
  "YFPAboutQ":"当社のJiraプロジェクトは、実際にはどれほどのコストがかかっているのでしょうか？",
  "YFPAbout":"Jira用Financial Portfolio\n財務責任者やPMOは、ある単純な質問に答えるのに苦労しています:\n当社のJiraプロジェクトは、実際にはどれほどのコストがかかっているのか？\nJiraは作業を追跡します。\n財務部門は予算を追跡します。\nこのアプリは、ついにその2つを結びつけます。\n\nFinancial Portfolioは、高価なエンタープライズツールを必要とせずに、Jiraを軽量なPPM＋財務計画プラットフォームに変えます。",
  "YFPPorfolioQ":"ポートフォリオ予算と追跡",
  "YFPPorfolioP":"複数のJiraプロジェクトにまたがるポートフォリオを作成し、予算額、通貨、期間、対象プロジェクト、チームを定義します。Jiraでの作業進捗に合わせて、実際のコストを自動的に追跡します。",
  "YFPPorfolioListQ":"ポートフォリオ",
  "YFPPorfolioListP":"複数のJiraプロジェクトを組み合わせた財務ポートフォリオを作成し、以下を即座に確認できます：予算対実績コスト、リアルタイムのプロジェクトバーンレート、CapEx対OpExの内訳、課題およびプロジェクトごとのコスト、エクスポート可能な財務レポート。すべてJiraの作業ログを直接活用して機能します。",
  "CostQ":"自動コスト計算",
  "CostP":"作業時間の記録を実際の財務データに変換します。このアプリは、Jiraの作業ログを読み取り、時間単価を適用し、毎日の実際のプロジェクトコストを計算します。スプレッドシートも手作業も不要です。",
  "RatesQ":"単価",
  "RatesP":"プロジェクト別、チーム別、または全社単位で時間単価を設定",
  "ReportQ":"CSV形式の財務レポート",
  "ReportP":"ポートフォリオの財務データを数秒でエクスポート。最適用途：財務チーム、CFO向けレポート、予算策定、監査対応",
  "SettingsQ":"CapExとOpExの分類",
  "SettingsP":"会計および監査要件に対応。作業を 資産化可能な開発（CapEx）と 運用業務（OpEx）に分類。財務チーム向けのエクスポート可能なレポートを生成します。"
};


export const documents = {
};
